// 
import React from 'react';

const EmployeeSubmission = () => {
    return (
        <div style={{ display: "flex", flexDirection: "column", padding: "20px" }}>
            <div style={{ maxWidth: "800px" }}>
                <h2 style={{ fontSize: "24px", fontWeight: "300", color: "#000000", marginBottom: "10px" }}>
                    Managing Submission Sheets
                </h2>

                <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    How to Add, Edit, and Delete Submission Sheets?
                </h3>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 1: Navigate to the Submission Module
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    Open the dashboard. Click on Submissions in the left-hand menu. You will be taken to the Submission Sheet page.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 2: Open the Submission Entry Sheet
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    On the Submission Sheet page, locate the Add button on the top right-hand side. Click the Add button to open the Submission Entry Sheet.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 3: Fill Out the Submission Entry Form
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Consultant and Client Information</strong>
                    <br />
                    Click the Consultant Name tab. A dropdown list will appear. Select the consultant's name.
                    <br />
                    Click the Client Name tab. A dropdown list will appear. Select the client’s name.
                </p>
                
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Vendor Details</strong>
                    <br />
                    Enter the Vendor Name in the appropriate field. Enter the Vendor Email Address in the provided field.
                    Type the Vendor Mobile Number in the designated box.
                    <br />
                    (Optional) If there is a secondary number, enter it in the Secondary Number field.
                </p>

                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Payment and Submission Details</strong>
                    <br />
                    Enter the Pay Rate in the respective field.
                    <br />
                    (Optional) Fill in the Submitted For field if applicable. If not, leave this field blank.
                    <br />
                    Type your name in the Submitted By field.
                </p>

                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Requirements and Status</strong>
                    <br />
                    Click on the Requirement Tab. A dropdown menu will appear. Select the candidate's preferred method of communication.
                    <br />
                    Click on the Status Tab. A dropdown menu will appear. Select the consultant's current status.
                </p>

                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Job Type</strong>
                    <br />
                    Click on the Job Type Tab. A dropdown menu will appear. Select the relevant job type.
                </p>
          

                <img
                    src=" https://res.cloudinary.com/danfpnuui/image/upload/v1737967561/1_tbnnmt.png "
                    alt="Submission Comments Guide"
                    className="placeholder-image"
                    style={{ width: '700px', height: 'auto', margin: '20px block' }} // Reduce image size
                />
                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 4: Save Your Submission
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    Review all the entered details for accuracy. Click the Save button to save the form. This process ensures the submission is added correctly to the system. If you encounter any issues, contact the Help Desk for support.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Ensuring Correct Submission: Comment Section to the System
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    This guide outlines the steps to ensure that your submission is correctly added to the system. If you encounter any issues, please reach out to the Help Desk for support.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 1: Accessing Consultant Details
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Navigate to the Consultant’s Profile</strong>
                    <br />
                    To begin, locate the consultant’s name or email address within the system. Click on the consultant’s name or email to access their profile.
                </p>    
                <img
                    src="   https://res.cloudinary.com/danfpnuui/image/upload/v1737967571/2_pxyhup.png "
                    alt="Submission Comments Guide"
                    className="placeholder-image"
                    style={{ width: '700px', height: 'auto', margin: '20px block' }} // Reduce image size
                />
                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 2: Navigating to the Submission Comments Section
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>View the Submission Comments</strong>
                    <br />
                    After selecting the consultant, you will be directed to the Submission Comments section. This section allows you to communicate directly with the employer, admin, consultant, or super admin.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 3: Contacting Relevant Parties
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Message the Appropriate Parties</strong>
                    <br />
                    In the Submission Comments section, you can send messages to the relevant parties (employer, admin, consultant, or super admin).
                    Use the message box to send any questions or comments to these individuals regarding the submission.
                </p>

                <h4 style={{ fontSize: "18px", fontWeight: "300", color: "#000000", marginTop: "10px", marginBottom: "10px" }}>
                    Step 4: Contacting Help Desk (If Needed)
                </h4>
                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                    <strong>Reach Out for Support</strong>
                    <br />
                    If you encounter any issues that you are unable to resolve, please contact the Help Desk for assistance. The Help Desk team is available to assist with any technical or system-related issues.
                </p>
            </div>
        </div>
    );
};

export default EmployeeSubmission;
